export default class Transaction {
  /**
   * @type {number}
   */
  id;

  /**
   * @type {number}
   */
  typeId;

  /**
   * @type {number}
   */
  officeId;

  /**
   * @type {number}
   */
  userId;

  /**
   * @type {number}
   */
  amount;

  /**
   * @type {number}
   */
  paymentType;

  /**
   * @type {boolean}
   */
  void;

  /**
   * @type {number}
   */
  adminEdit;

  /**
   * @type {string}
   */
  date;

  constructor(opts = null) {
    if (opts != null) {
      if (opts.id != null) {
        this.id = opts.id;
      }
      if (opts.typeId != null) {
        this.typeId = opts.typeId;
      }
      if (opts.officeId != null) {
        this.officeId = opts.officeId;
      }
      if (opts.userId != null) {
        this.userId = opts.userId;
      }
      if (opts.amount != null) {
        this.amount = opts.amount;
      }
      if (opts.paymentType != null) {
        this.paymentType = opts.paymentType;
      }
      if (opts.void != null) {
        this.void = opts.void;
      }
      if (opts.adminEdit != null) {
        this.adminEdit = opts.adminEdit;
      }
      if (opts.date != null) {
        this.date = opts.date;
      }
    }
  }
}
